<template functional>
  <div class="sixteen wide column">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'SixteenWideColumn'
}
</script>

<style scoped>

</style>
